module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp12_3.733a5f1c.png";